// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__YLBdR","link":"Breadcrumb_link__aM95j"};